var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page container-xl"},[_c('page-header',{attrs:{"title":"Download Items","description":"View and download your purchased items."}}),_vm._l((_vm.cartItems),function(item,index){return _c('download-item',{key:index,attrs:{"item":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }